import type { ITeacherCourse, ITeacherCoursesResponse } from '../api/types';

type TeacherCourseGroupKey =
  'mastersDegreeCourses' | 'postgraduateCourses' | 'bachelorsDegreeCourses' | 'shortCourses';

interface TeacherCourseGroup {
  key: TeacherCourseGroupKey;
  type: 'masters-degree' | 'postgraduate' | 'bachelors-degree' | 'short';
  title: string;
  showWhenEmpty: boolean;
}

export const TEACHER_COURSE_GROUPS: TeacherCourseGroup[] = [
  {
    key: 'mastersDegreeCourses',
    type: 'masters-degree',
    title: "Master's Degree",
    showWhenEmpty: true,
  },
  { key: 'postgraduateCourses', type: 'postgraduate', title: 'Postgraduate', showWhenEmpty: false },
  {
    key: 'bachelorsDegreeCourses',
    type: 'bachelors-degree',
    title: "Bachelor's Degree",
    showWhenEmpty: false,
  },
  { key: 'shortCourses', type: 'short', title: 'Short course', showWhenEmpty: true },
];

export const getTeacherCourseGroups = (
  data?: ITeacherCoursesResponse,
): (TeacherCourseGroup & { courses: ITeacherCourse[] })[] =>
  TEACHER_COURSE_GROUPS.map((group) => ({ ...group, courses: data?.[group.key] ?? [] }));
